import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-int-user-navbar',
  templateUrl: './int-user-navbar.component.html',
  styleUrls: ['./int-user-navbar.component.scss']
})
export class IntUserNavbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
